import React from 'react';
import classNames from 'classnames';

import RadioSelect from '../../components/radios';

import TranslationIds from '../../../commons/translationIds';

function renderGender (p) {
    const {
        fields,
        // fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        subscribersFields,
    } = p;

    if (!fields || (!fields.gender)) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        if (fields.gender === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_GENDER)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_GENDER);
    }

    function getOptions () {
        return [
            { value: 'M', label: translate(TranslationIds.COMPONENT_MALE)},
            { value: 'F', label: translate(TranslationIds.COMPONENT_FEMALE)},
            { value: 'NB', label: translate(TranslationIds.COMPONENT_GENDER_NON_BINARY)},
            { value: 'NA', label: translate(TranslationIds.COMPONENT_GENDER_NOT_TO_DISCLOSE)},
        ];
    }

    function getValue () {
        if (!subscribersFields.gender) {
            return null;
        }
        return subscribersFields.gender;
    }

    return (
        <RadioSelect
            title={getLabel()}
            className={classNames(['ecal-reg-field-gender', classes.radioGroup])}
            options={getOptions()}
            onChange={({ value }) => {
                if (typeof setSubscribersFields === 'function') {
                    setSubscribersFields({
                        gender: value,
                    });
                }
            }}
            value={getValue()}
        />
    );
}

export default renderGender;